<template>
<main-content>
    <kt-panel v-if="!profile_completed">
        <kt-panel-body>
            <span :style="{fontSize:'1.25em'}">
                {{ $t('authenticate.complete_profile') }}
            </span>
        </kt-panel-body>        
    </kt-panel>
    <kt-panel v-else-if="is_authenticated_pending">
        <kt-panel-body>
            <span :style="{fontSize:'1.25em'}">
                {{ $t('authenticate.pending') }}
            </span>
        </kt-panel-body>
    </kt-panel>
    <kt-panel v-else-if="is_authenticated && profile_completed">
        <kt-panel-body>
            <span :style="{fontSize:'1.25em'}">
                {{ $t('authenticate.accepted') }}
            </span>
        </kt-panel-body>
    </kt-panel>
    <kt-panel v-else>
        <kt-panel-body>

            <kt-form-group v-if="current_user.status == userStatus.AUTHORIZATION_DOCUMENTS_REJECTED">
                <kt-form-label for="rejected_status_description">
                    {{ $t('label.auth_documentation_rejection_reason') }}
                </kt-form-label>
                <textarea
                        class="form-control no-resize"
                        rows="6"
                        id="rejected_status_description"
                        name="rejected_status_description"
                        v-model="current_user.rejected_status_description"
                        disabled
                ></textarea>
            </kt-form-group>

            <ul class="list-group mb-3">
                <li class="border-0 px-0 py-1 list-group-item">{{ $t('authenticate.hint.first') }}</li>
                <li class="border-0 px-0 py-1 list-group-item">{{ $t('authenticate.hint.second') }}</li>
                <li class="border-0 px-0 py-1 list-group-item">{{ $t('authenticate.hint.third') }}</li>
                <li class="border-0 px-0 py-1 list-group-item">{{ $t('authenticate.hint.fourth') }}</li>
                <li class="border-0 px-0 py-1 list-group-item">{{ $t('authenticate.hint.fifth') }}</li>
            </ul>

            <form @submit.prevent="submitForm" class="mt-2">
                <kt-form-group class="mb-1">
                    <kt-form-label for="authenticate_file" class="btn btn-secondary btn-wide label-file">
                        <kt-icon type="fa" name="paperclip"></kt-icon>
                        <span v-if="current_user.user_type == user_types.LEGAL">{{ $t('label.signature_holder_authenticate_file') }}</span>
                        <span v-else>{{ $t('label.authenticate_file') }}</span>
                    </kt-form-label>
                        <input 
                            @change="processAuthenticateFile" 
                            type="file"
                            name="authenticate_file" 
                            id="authenticate_file"
                            class="custom-file-upload"
                            accept=".jpg,.jpeg,image/png"
                        />
                          <img :src="picPreviewAuthenticated" class="preview_picture"  v-if="picPreviewAuthenticated !== ''"/>
                          <i class="fa fa-window-close text-danger remove_picture" v-if="picPreviewAuthenticated !== ''" @click="removePicture('authenticated')"></i>
                </kt-form-group>

                <kt-form-group class="mb-1">
                    <kt-form-label for="national_card_file" class="btn btn-secondary btn-wide label-file">
                        <kt-icon type="fa" name="paperclip"></kt-icon>
                        <span v-if="current_user.user_type == user_types.LEGAL">{{ $t('label.signature_holder_national_card_file') }}</span>
                        <span v-else>{{ $t('label.national_card_file') }}</span>
                    </kt-form-label>
                        <input
                            @change="processNationalCardFile" 
                            type="file"
                            name="national_card_file"
                            id="national_card_file"
                            class="custom-file-upload"
                            accept=".jpg,.jpeg,image/png"
                        />
                          <img :src="picPreviewNational" class="preview_picture"  v-if="picPreviewNational !== ''"/>
                          <i class="fa fa-window-close text-danger remove_picture" v-if="picPreviewNational !== ''" @click="removePicture('national')"></i>
                </kt-form-group>

                <kt-form-group class="mb-1" v-if="current_user.user_type == user_types.LEGAL">
                    <kt-form-label for="latest_change_file" class="btn btn-secondary btn-wide label-file">
                        <kt-icon type="fa" name="paperclip"></kt-icon>
                        {{ $t('label.rrk_latest_change') }}
                    </kt-form-label>
                        <input
                            @change="processLatestChangeFile" 
                            type="file"
                            name="latest_change_file"
                            id="latest_change_file"
                            class="custom-file-upload"
                            accept=".jpg,.jpeg,image/png"
                        />
                          <img :src="picPreviewLatest" class="preview_picture"  v-if="picPreviewLatest !== ''"/>
                          <i class="fa fa-window-close text-danger remove_picture" v-if="picPreviewLatest !== ''" @click="removePicture('latest')"></i>
                </kt-form-group>

                <kt-form-action class="mt-4">
                    <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
                        {{ $t('btn.submit') }}
                    </button>
                </kt-form-action>
            </form>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from './Base'
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { userService } from '@/common/api.service'
import { mapGetters } from 'vuex'
import {i18n} from "../../plugins/i18n";
import { userStatusStr, userStatus } from '@/constants/userStatus'
import { userTypes } from '@/constants/userTypes';

export default {
    components: {
	    'main-content': mainContent
    },
    data() {
        return {
            authenticate_file: null,
            national_card_file: null,
            userStatus: userStatus,
            latest_change_file: null,
            user_types: userTypes,
            picPreviewAuthenticated: '',
            picPreviewNational: '',
            picPreviewLatest: '',
        }
    },
    computed: {
        ...mapGetters('user', [
            'is_authenticated_pending',
            'profile_completed',
            'is_authenticated',
            'current_user'
        ])
    },
    beforeRouteEnter (to, from, next) {
        next(vm => 
            vm.$store.dispatch('user/fetchCurrent').then(() => {
                if(vm.profile_completed && vm.is_authenticated) {
                    // vm.$router.push('/profile')
                }
            })
        )
    },
    methods: {
        submitForm(e) {
            let form = $(e.target)
            let btn = $('#submit_btn')

            form.validate({
                rules: {
                    authenticate_file: {
                        required: true,
                    },
                    national_card_file: {
                        required: true,
                    },
                    latest_change_file: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.LEGAL;
                        },
                    }
                }
            })

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn);

            let form_data = new FormData()
  		    form_data.append('authenticate_file', this.authenticate_file)
  		    form_data.append('national_card_file', this.national_card_file)

            if (this.current_user.user_type == this.user_types.LEGAL) {
                form_data.append('latest_change_file', this.latest_change_file);

                userService.authenticate_legal_user(form_data)
                .then(response => {
                    this.$store.commit('user/setAuthenticatePending')
                    this.$store.dispatch('badgeCounter/countData')
                })
                .catch(({response}) => {
                    //
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                });
            } else {
                userService.authenticate(form_data)
                .then(response => {
                    this.$store.commit('user/setAuthenticatePending')
                    this.$store.dispatch('badgeCounter/countData')
                })
                .catch(({response}) => {
                    //
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
            }
        },
        processAuthenticateFile(e) {
            this.picPreviewAuthenticated = URL.createObjectURL(event.target.files[0]);
            this.authenticate_file = event.target.files[0]
            this.validateSize(event.target)
            this.validateFormat(event.target)
        },
        processNationalCardFile(e) {
            this.picPreviewNational = URL.createObjectURL(event.target.files[0]);
            this.national_card_file = event.target.files[0]
            this.validateSize(event.target)
            this.validateFormat(event.target)
        },
        processLatestChangeFile(e) {
            this.picPreviewLatest = URL.createObjectURL(event.target.files[0]);
            this.latest_change_file = event.target.files[0]
            this.validateSize(event.target)
            this.validateFormat(event.target)
        },
        removePicture(type){
            switch(type){
                case 'authenticated':
                    this.picPreviewAuthenticated = ''
                    return
                case 'national':
                    this.picPreviewNational = ''
                    return
                case 'latest':
                    this.picPreviewLatest = ''
                    return
            }
        },
        validateSize(file) {
            var FileSize = file.files[0].size / 1024 / 1024; // in MB
            if (FileSize > 1) {
                alert(i18n.t('authenticate.hint.fourth'));
                $(file).val('');
            } else {

            }
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, '');
            if (extension === file_name) {
                extension = '';
            } else {
                extension = extension.toLowerCase();
            }

            switch (extension) {
                case 'jpg':
                case 'jpeg':
                case 'png':
                    break;
                default:
                    alert(i18n.t('authenticate.input_format_err'));
                    $(file).val('');
            }
        }
    },
}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    display: inline-block;
    cursor: pointer;
    min-width: 200px;
}
input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}

.preview_picture{
  position: relative;
  width: 200px;
  height: 100px;
}

.remove_picture{
  cursor: pointer;
  position: absolute;
}
</style>